<div class="flex layout-col">
  <div class="flex-none layout-row place-start-center p-sm segment-border">
    <button
      mat-icon-button
      (click)="chooseProductionRoute(item())"
      [disabled]="item().processingState !== workItemStates.OPEN"
    >
      <mat-icon>edit</mat-icon>
    </button>

    @if (item().productionRoute; as productionRoute) {
      @for (segment of productionRoute.sequence; track segment) {
        <div class="flex-none layout-row">
          <!-- Transport -->
          <div class="flex-none layout-col place-center-center">
            <div class="layout-col" style="width: 100%">
              <div class="transport"></div>
            </div>
            <span class="mat-caption" style="min-width: 50px; text-align: center">
              {{ segment.plannedTransportCost | isoDuration: 'hh:mm' }}&#8203;
            </span>
          </div>
          <!-- Segment W/C Operation -->
          <div class="flex-none layout-col place-center-center">
            <div class="layout-col segment" [matTooltip]="segment.workCenterName">
              <span class="mat-subtitle-2">{{ segment?.workCenterNumber }}</span>
              <div class="layout-row gap-sm">
                @for (action of segment.actions; track action) {
                  <div>
                    <mat-chip highlighted>
                      <span class="mat-caption">{{ action }}</span>
                    </mat-chip>
                  </div>
                }
              </div>
            </div>
            <span class="mat-caption"
              >{{
                showMakespan(segment) ? (segment.plannedMakeSpan | isoDuration: 'hh:mm') : '-'
              }}&#8203;</span
            >
          </div>
        </div>
      }
    }
  </div>
</div>
